// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1Vf7R","inputWrap":"CustomTip_inputWrap__2FtXf"};